import { render, staticRenderFns } from "./no-tokens.vue?vue&type=template&id=230888a6&scoped=true&"
import script from "./no-tokens.vue?vue&type=script&lang=ts&"
export * from "./no-tokens.vue?vue&type=script&lang=ts&"
import style0 from "./no-tokens.vue?vue&type=style&index=0&id=230888a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230888a6",
  null
  
)

export default component.exports